import './benefit-box.styles.css';

const BenefitBox = ({cat}) => {
    const {text , icon } = cat;
  return (
    <div className='benefit-box'>
        <span className="benefit-box-icon">
            {icon}
        </span>
        <h5 className="benefit-text">
            {text}
        </h5>
    </div>
  )
}

export default BenefitBox